module.exports = __webpack_public_path__ + "static/media/122.afca5295.jpg";